export default "__VITE_ASSET__BHGT3AwB__"